import React,{useState, useEffect} from 'react';
import { Label } from '../atoms/label';
import { Line } from '../atoms/line';
import ConditionDesignationArea from '../molecules/conditionDesignationArea';
import { CourseCountAndButton } from '../molecules/courseCountAndButton';
import img_arw from '../../resources/icons/arw_pulldown.svg';
import img_modal from '../../resources/icons/ico_modal.svg';
import { searchResultApi, golfFacility } from "../../const";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import common from "../../resources/js/common/common";
import { ModalClose } from '../atoms/modalClose';

const GolfPlanSearchSpContainer = (props) => {
    const { playDate1,  
        group, 
        course,
        detailCondition,
        startTime,
        setSearchResult,
        kaiinken,
        onClickOpenSelectDateWindow, 
        setReserveCheckInfo,
        onClickOpenStartTimeWindow, 
        onClickOpenSelectAreaWindow,
        setChangeReserveNo,
        addTeeTimeList,
        changeReserveNo} = props;

    const [conditionsCloseFlg, setConditionsCloseFlg] = useState(false);
    const popConditionsClose = () => {
        props.setState(false);
        setConditionsCloseFlg(true);
    }
    const history = useHistory();
    
    // 検索ボタン押下時
    const onClickSearch = () => {
        addTeeTimeList([]);
        setReserveCheckInfo([]);
        setChangeReserveNo("");
        // 選択した詳細条件をstoreに保存
        const arry = [];
        const elements = document.getElementsByClassName("play_style");
        for (let i in elements) {
            if (elements[i].checked == true) {
                arry.push(elements[i].value);
            }
        }

        for (let i in detailCondition) {
            let index = arry.indexOf(detailCondition[i].id);
            if (index >= 0) {
                detailCondition[i].checked = true;
            } else {
                detailCondition[i].checked = false;
            }
        }

        let groupNumber = 1;
        group.forEach((data) => {
            if (data.selected === true) groupNumber = parseInt(data.id); 
        });

        const courseArray = [];
        course.forEach((data) => {
            if (data.checked === true) courseArray.push(data.id);
        });

        //選択された会員権から施設コードを詰め込む
        // const courseArrayKaiinken = [];
        // kaiinken.forEach((data) => {
        //     if (data.selected === true) courseArrayKaiinken.push(data.facilityCd);
        // });

        //選択された会員権から施設コードを詰め込む
        let courseArrayKaiinken;
        let useMemberShipAuth;
        let kaiinKind;
        kaiinken.forEach((data) => {
            if (data.selected === true) {
                courseArrayKaiinken = data.sisetuCd;
                kaiinKind = data.kaiinkenSyubetCd;
                course.forEach((courseData) => {
                    if(courseData.id === data.facilityCd){
                        useMemberShipAuth = courseData.memberShipAuth
                    }
                })
            }
        });

        const detailArray = [];
        detailCondition.forEach((data) => {
            if (data.checked === true) detailArray.push(data.id);
        });

        const startTimeArray = [];
        let startTimeFlg = false;
        startTime.forEach((data) => {
            if (data.checked === true) startTimeFlg = true;
            if (data.checked === true) startTimeArray.push(data.id);
        });
        // スタート時間が1件もチェックが入っていない場合、全件チェック
        if(startTimeFlg === false) {
            startTime.forEach((data) => {
                startTimeArray.push(data.id);
            });
        }

        const playDate = new Date(playDate1);
        let y = playDate.getFullYear();
        let m = playDate.getMonth() + 1;
        let d = playDate.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`

        // リクエスト情報設定
        const req = {
            playDate: `${y}-${m}-${d}`,
            partyCount: groupNumber,
            courseId: courseArray,
            playStyle: detailArray,
            teeTime: startTimeArray,
            membershipAuthID:useMemberShipAuth,
            userFacility: courseArrayKaiinken,
            kaiinKind:kaiinKind,
            days: '1',
        };
        
        console.log(req);

        common.doPost(searchResultApi, req, afterSearchResult);

    }

    let resDataList = [];
    //検索API通信後の処理
    const afterSearchResult = (res) => {
        //検索API戻り値を一時的に保持
        resDataList = res;
        // common.doPost(golfFacility, {}, afterGolfFacility);
        kaiinken.forEach((data) => {
            if (data.selected === true) {
                common.doPost(golfFacility, {kaiinKind:data.kaiinkenSyubetCd,sisetuCd:data.sisetuCd}, afterGolfFacility);
            }
        })
    }

    //施設取得API通信後の処理
    const afterGolfFacility = (facilityData) => {
        //検索APIの戻り値を格納
        const res = resDataList;
        if(res.data.golfCourses){
            const result = facilityData.data.map((item) => {

                for(let i=0; i < res.data.golfCourses.length; i++ ) {
                    if(res.data.golfCourses[i].name === item.facility_name) {
                        const resData = res.data.golfCourses[i];
                        const fac = {
                            courseid: item.courseid,
                            zip: item.zip,
                            address: item.address,
                            access_car: item.access_car,
                            facility_overview_title: item.facility_overview_title,
                            facility_overview_detail: item.facility_overview_detail,
                            url: item.url,
                            image_path:item.image_path,
                        }
                        Object.assign(resData, fac);
                        return resData;
                    }
                }
                return null;
            });

            const re = result.filter(item => item != null);

            console.log("data");
            console.log(res.data);
            const resultData = {
                sort: "人気順",
                golfCourses: re
            }
            console.log(resultData);

            //表示施設のソート処理
            resultData.golfCourses.sort(function(first,second){
                if (first.facilitySort > second.facilitySort){
                    return 1;
                }else if (first.facilitySort < second.facilitySort){
                    return -1;
                }else{
                    return 0;
                }
            })

            setSearchResult(resultData);
        }
        else{
            setSearchResult([]);
        }

        // 画面遷移
        props.setState(false);
        setConditionsCloseFlg(true);
    }

    // コース数表示処理
    const getCourseCount = () => {
        
        let count = 0;
        for (let i in course) {
            if (course[i].checked === true) {
                count += 1;
            }
        }
        return count;
    }

    return (
        <div style={!conditionsCloseFlg ? styles.container : styles.popNone}>
            <div style={styles.content}>
                <div style={styles.header}>
                    <Label label="検索条件の変更" style={styles.popTitle} />
                    <ModalClose divStyle={"modalCloseSp"} svgStyle={"modalSvg"} onClick={popConditionsClose}/>
                </div>
                <div style={{height:"50px"}}/>
                <div style={styles.popBody}>
                    <ConditionDesignationArea
                        style={style}
                        isMobilePhone={true}
                        onClickOpenSelectDateWindow={onClickOpenSelectDateWindow}
                        onClickOpenStartTimeWindow={onClickOpenStartTimeWindow}
                        onClickOpenSelectAreaWindow={onClickOpenSelectAreaWindow} 
                        noDisplay={false}/>
                </div>
                <Line />
                <div style={styles.popBtn}>
                    <CourseCountAndButton course={getCourseCount()} onClick={onClickSearch} label={"検索"} />
                </div>
            </div>
        </div>
    );
}

const style = {
    wrapper: {
        backgroundColor: "rgba(242, 242, 242, 0.95)",
        textAlign: "center",
        width: "70%",
        margin: "auto",
        marginTop: "80px",
        marginBottom: "80px",
        padding: "60px 100px",
    },
    wrapperMobile: {
        backgroundColor: "#f2f2f2",
        textAlign: "center",
        width: "80%",
        margin: "auto",
        marginTop: "40px",
        padding: "30px 10px",
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    detailsButton: {
        color: "#4d4d4d",
        backgroundColor: "#d9d7d7",
        border: "none",
        padding: "10px 10px 10px 10px",
        width: "100%",
        position: "relative",
        boxSizing:'border-box',
    },
    detailLabel: {
        display: "inline-block",
    },
    detailImage:{
        display: "inline-block",
        position: "absolute",
        right: "0",
        marginRight: "10px",
    },
    icon: {
        display: "block",
        position: "absolute",
        top: "10px",
        left: "40%",
        transform: "translate(0, 50%)"
    },
    wrap: {
        width: "48%",
        textAlign: "left",
        marginBottom: "20px",
    },
    wrapMobile: {
        width: "100%",
        textAlign: "left",
        marginBottom: "10px",
    },
    label: {
        color: "#696969",
        margin: "5px 0",
        fontSize:14
    },
    modalOptionStyle: {
        backgroundColor: "#fff",
        border: "solid 1px #adadad",
        padding: "10px 40px 10px 20px",
        position: "relative",
        display: "block",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        backgroundImage: `url(${img_modal})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: "right 10px center",
    },
    pullDownOptionStyle: {
        border: "solid 1px #adadad",
        padding: "13px 20px",
        width: "100%",
        outline: "none",
        appearance: "none",
        backgroundImage: `url(${img_arw})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: "right 10px center",
    },
    pullDownOptionKaiinkenStyle: {
        border: "solid 1px #adadad",
        padding: "15px 30px 15px 20px",
        width: "100%",
        outline: "none",
        appearance: "none",
        backgroundImage: `url(${img_arw})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: "right 10px center",
        cursor: "pointer",
    },
    detailedConditionContainer: {
        width: "100%",
        border: "solid 1px #adadad",
        marginTop: "30px",
    },
    detailedConditionArea: {
        backgroundColor: "#fff",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-around",
        width: "100%",
    },
    courseCount: {
        margin:0,
        marginBottom: 5,
        textAlign:"center"
    },
    // CheckboxListBoxコンポーネントに引数として渡すスタイル情報
    divStyle: {
        display: "flex",
        flexWrap: "wrap",
        width: "45%",
        textAlign: "left",
        alignContent: "flex-start",
    },
    divStyleMobile: {
        display: "flex",
        flexWrap: "wrap",
        width: "90%",
        textAlign: "left",
        alignContent: "flex-start",
    },
    labelAreaStyle: {
        color: "#696969",
        width: "100%",
        borderBottom: "solid 1px #696969",
        marginTop: "30px",
        marginBottom: "15px",
    },
    // プレイスタイルの各チェックボックス要素の並び(2列)
    playStyleCheckArea: {
        width: "50%",
        paddingBottom: "15px",
    },
    // スタート時刻の各チェックボックス要素の並び(3列)
    startTimeCheckAreaStyle: {
        width: "30%",
        paddingBottom: "15px",
    },
    startTimeCheckAreaStyleMobile: {
        width: "50%",
        paddingBottom: "15px",
    },
    vacancy__title: {
        fontWeight: "bold",
        fontSize: "1.5rem",
        float: "left",
    },
    line: {
        clear: "both",
    },
}
const styles = {
    container: {
        //position:"absolute",
        position: "fixed",
        top: "0",
        left: "0",
        height: "100%",
        width: "100%",
        zIndex:1000,
        backgroundColor: "rgba(0,0,0,0.5)",
    },
    content: {
        position: "absolute",
        //zIndex:2000,
        top: "10%",
        width: "100%",
        height: "90%",
        backgroundColor: "white",
        overflow: "auto",
    },
    header: {
        width: "100%",
        padding: "inherit",
        background: "inherit",
        height:50,
        position:"fixed",
        zIndex:9999,
        borderBottom:"1px solid gray"
    },
    popTitle: {
        paddingTop: "30px",
        textAlign: "center",
    },
    popTitle: {
        fontWeight: "bold",
        textAlign: "center",
        margin: "15px",
    },
    popBody: {
        margin: "30px",
    },
    popBtn: {
        marginBottom: 15,
        marginTop:20
    },
}
const mapStateToProps = (state) => {
    return {
        playDate1: state.playDate1,
        group: state.group,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        kaiinken: state.kaiinken,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setReserveCheckInfo: (item) => {
            dispatch({ type: "RESERVE_CHECK_INFO", payload: { reserveCheckInfo: item } })
        },
        setChangeReserveNo: (item) => {
            dispatch({ type: "CHANGE_RESERVE_NO", payload: { changeReserveNo: item } })
        },
        addTeeTimeList: (item) => {
            dispatch({ type: "ADD_TEETIME_LIST", payload: { teeTimeList: item } })
        },
    };
}
export default connect(mapStateToProps, mapToDispatchToProps)(GolfPlanSearchSpContainer);